jQuery(document).ready(function(){
  jQuery('.site-footer .collapsible-content a').each(function(){
    if(jQuery(this).text() == "Track An Order"){
    	jQuery(this).attr('href',false);
      	jQuery(this).addClass('trackOrderLink');
      	jQuery('.trackOrderLink').click(function(){
      		jQuery('#track_order_wrap').show();
          	return false;
      	});
    }
  });
  jQuery('.close.skip-link-close').click(function(){
  		jQuery('#track_order_wrap').hide();
  });
  jQuery('#req').click(function(){
  		var to_oid = jQuery("#to_oid").val();
    	var to_email = jQuery("#to_email").val();
    	var error = false;	
    	if(to_oid == ""){
        	jQuery(".myerror.to_oid").show();
          	error = true;
        }else{
        	jQuery(".myerror.to_oid").hide();
        }
    	
    	if(to_email == ""){
        	jQuery(".myerror.to_email").show();
          	error = true;
        }else{
        	jQuery(".myerror.to_email").hide();
        }
    	if(!error){
          var mydata = {order_id:to_oid,email:to_email};
          	jQuery('#track_order_wrap').addClass('loading');
        	jQuery.ajax({
        		type: "POST",
        		url: 'http://mkmage.com/housemeethome/trackorder.php',
        		dataType: 'json',
              	contentType: 'application/json',
              	data: JSON.stringify(mydata), 
        	  	success: function(data){
                  if(data.success == 0){
                    jQuery('#order_messages').html(data.message);
                  }else{
                  	jQuery('#order_messages').html('');
                    jQuery('#my-to-content').html(data.message);
                    jQuery('div#track_order .heading img').addClass('active');
                    jQuery('body').addClass('track-order');
                  }
                  jQuery('#track_order_wrap').removeClass('loading');
        		}
        	});
         
        }
  });
});